import Cookies from 'js-cookie'

export default {
  init() {

	/**
	 * Mobile
	 */
	$('#mobile-bar-search-toggle').click(function(){
		$('#mobile-bar-search').slideToggle();
	});

	$('#mobile-menu-toggle').click(function(){
		$('#mobile-menu').toggleClass('show');
	});

	$('.mobile-menu-navigation li.menu-item-has-children .arrow').click(function(e){
        e.preventDefault();
        let li = $(this).parents('li').first();
        let sub = li.find('ul').first();
        li.toggleClass('active');
        sub.slideToggle(300);
    });

	/**
	 * Switch input
	 */
	$('.switch_input').change(function(){
		var target = $(this).data('target');
		if(target != '0'){
			$('#'+target).slideToggle();
		}
	});

	$('.switch_input').each(function(){
		var target = $(this).data('target');

		if(target != '0' && $(this).is(':checked')){
			$('#'+target).slideToggle();
		}
	});

	/**
	 * Modals
	 */
	const infoModal = $('#info-modal');
	const tippModal = $('#tipp-modal');

	if(infoModal.length){
		let cookie = Cookies.get('info_modal_closed');
		if(cookie != 1){
			infoModal.modal('show')
		}

		infoModal.on('hide.bs.modal', function () {
			Cookies.set('info_modal_closed', 1)
		})
	}

	$('#modal-added-to-cart').modal('show');

	$('.tip-modal-trigger').click(function(e){
		e.preventDefault();
		let tipId = $(this).data('id');

		$.ajax({
			type: 'POST',
			url: kampa.ajax_url,
			data: {
				action: 'kampa_tip_modal',
				tip: tipId,
			},
			success: function (res) {
				if(res){
					let data = JSON.parse(res);
					console.log(data);
					tippModal.find('.modal-tipp__title').html(data.title);
					tippModal.find('.modal-tipp__content').html(data.content);
					tippModal.modal('show');
				}
			},
		});


	});
  },
  finalize() {
    //JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js